/**
 * Resolve the parent window's origin for postMessage targeting.
 * Prefers an explicit `parentOrigin` query param (set by widget loaders),
 * falls back to `document.referrer`.
 */
export function readParentOrigin(): string {
  if (typeof document === 'undefined') return '*';
  try {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search || '');
      const raw = String(params.get('parentOrigin') || '').trim();
      if (raw) {
        const u = raw.includes('://') ? new URL(raw) : new URL(raw + '/');
        return u.origin;
      }
    }
  } catch {
    // fall through to referrer parsing
  }
  const ref = String(document.referrer || '').trim();
  if (!ref) return '*';
  try {
    return new URL(ref).origin;
  } catch {
    return '*';
  }
}
